import React from 'react';
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminRoute from "./components/auth/AdminRoute";

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import NewSubmissionPage from "./pages/NewSubmissionPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import GradingStandardsPage from "./pages/GradingStandardsPage";
import DashboardPage from "./pages/DashboardPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import PrintPackingSlipPage from "./pages/PrintPackingSlipPage";
import ShippingInstructionsPage from "./pages/ShippingInstructionsPage";
import AdminPage from "./pages/AdminPage";
import AdminSubmissionDetailPage from "./pages/AdminSubmissionDetailPage";
import AdminDealersPage from "./pages/AdminDealersPage";
import AdminVouchersPage from "./pages/AdminVouchersPage";
import AdminPromosPage from "./pages/AdminPromosPage";
import DealerProgramPage from "./pages/DealerProgramPage";
import DealerApplyPage from "./pages/DealerApplyPage";
import DealerDashboardPage from "./pages/DealerDashboardPage";
import DealerTermsPage from "./pages/DealerTermsPage";
import VoucherTermsPage from "./pages/VoucherTermsPage";
import SubmissionDetailPage from "./pages/SubmissionDetailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/grading-standards" element={<GradingStandardsPage />} />
            <Route path="/dealer-program" element={<DealerProgramPage />} />
            <Route path="/dealer-terms" element={<DealerTermsPage />} />
            <Route path="/voucher-terms" element={<VoucherTermsPage />} />
            
            {/* QR code redirect - slabs link to homepage for now */}
            <Route path="/slab" element={<Navigate to="/" replace />} />
            
            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />
            <Route path="/submit" element={
              <ProtectedRoute>
                <NewSubmissionPage />
              </ProtectedRoute>
            } />
            <Route path="/new-submission" element={
              <ProtectedRoute>
                <NewSubmissionPage />
              </ProtectedRoute>
            } />
            <Route path="/payment/success" element={
              <ProtectedRoute>
                <PaymentSuccessPage />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <AccountSettingsPage />
              </ProtectedRoute>
            } />
            <Route path="/settings/payment" element={
              <ProtectedRoute>
                <AccountSettingsPage />
              </ProtectedRoute>
            } />
            <Route path="/submissions/:submissionId/print" element={
              <ProtectedRoute>
                <PrintPackingSlipPage />
              </ProtectedRoute>
            } />
            <Route path="/submissions/:submissionId" element={
              <ProtectedRoute>
                <SubmissionDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/shipping-instructions" element={
              <ProtectedRoute>
                <ShippingInstructionsPage />
              </ProtectedRoute>
            } />
            
            {/* Dealer routes */}
            <Route path="/dealer/apply" element={
              <ProtectedRoute>
                <DealerApplyPage />
              </ProtectedRoute>
            } />
            <Route path="/dealer/dashboard" element={
              <ProtectedRoute>
                <DealerDashboardPage />
              </ProtectedRoute>
            } />
            
            {/* Admin routes */}
            <Route path="/admin" element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            } />
            <Route path="/admin/submissions/:submissionId" element={
              <AdminRoute>
                <AdminSubmissionDetailPage />
              </AdminRoute>
            } />
            <Route path="/admin/dealers" element={
              <AdminRoute>
                <AdminDealersPage />
              </AdminRoute>
            } />
            <Route path="/admin/vouchers" element={
              <AdminRoute>
                <AdminVouchersPage />
              </AdminRoute>
            } />
            <Route path="/admin/promos" element={
              <AdminRoute>
                <AdminPromosPage />
              </AdminRoute>
            } />
            <Route path="/admin/*" element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            } />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
